import { REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants';
import { useMemo } from 'react'
import { useSelector } from 'react-redux';
import useFeatureFlagsForAccounts from './useFeatureFlagsForAccounts';

const useNewBrandUI = () => {
    const [isFeatureFlagActiveForAccounts] = useFeatureFlagsForAccounts();

    const { brands, current_account } = useSelector(state => ({
        brands: state.Brands.brands,
        current_account: state.accounts.current_account,
    }))
    const accountHasMultipleBrands = brands?.length > 1
    const show_rtb_brand_ui_changes = useMemo(() => {
        if (!current_account) return false
        return isFeatureFlagActiveForAccounts(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_RTB_BRAND_UI_CHANGES, current_account) && current_account?.internal && accountHasMultipleBrands
    }, [isFeatureFlagActiveForAccounts, current_account, accountHasMultipleBrands])
    return show_rtb_brand_ui_changes
}

export default useNewBrandUI